import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import confirm from '../../confirm'

import api from "../../../api/backend"

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    submit: {
        marginTop: 20
    },
    table: {
        marginTop: 50
    }
});

class Editor extends Component {
    state = {
        open: false, paymentStatus: '', type: ''
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    updateMyCourse = () => {
        const { course } = this.props
        const { paymentStatus, type } = this.state
        api.updateMyCourse(course.id, { paymentStatus, type }).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถบันทึกการลงทะเบียนได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    deleteMyCourse = () => {
        const { course } = this.props

        confirm(`ต้องการลบ '${course.course.title}' ของ '${course.user}' ใช่หรือไม่?`).then(
            (result) => {
                api.deleteMyCourse(course.id).then(([response, json]) => {
                    if (response.status === 200) {
                        this.setState({ open: false })
                        if (this.props.onUpdateCompleted) {
                            this.props.onUpdateCompleted()
                        }
                    } else {
                        console.error('ไม่สามารถลบการลงทะเบียนได้')
                    }
                }).catch(() => {
                    console.error('ไม่สามารถเชื่อมต่อ service ได้')
                })
            },
            (result) => { }
        )
    }

    toggleMyCourse = () => {
        const { course } = this.props
        api.toggleMyCourse(course.id).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถลบการลงทะเบียนได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    componentWillMount() {
        const { paymentStatus, type } = this.props.course
        this.setState({ paymentStatus, type })
    }

    render() {
        const { paymentStatus, type } = this.state
        const { course } = this.props
        const { classes } = this.props
        return (
            <React.Fragment>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>
                <IconButton aria-label="CheckBox" onClick={this.toggleMyCourse}>
                    {course.deactivated ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
                <IconButton aria-label="Delete" onClick={this.deleteMyCourse}>
                    <DeleteIcon />
                </IconButton>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="form-dialog-title">แก้ไขการลงทะเบียน</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={24} >
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel htmlFor="paymentStatus-helper">เลือกสถานะการชำระเงิน</InputLabel>
                                    <Select
                                        value={paymentStatus}
                                        onChange={(event) => { this.setState({ paymentStatus: event.target.value }) }}
                                        input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Inprogress">รอชำระ</MenuItem>
                                        <MenuItem value="Completed">ชำระแล้ว</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกสถานะการชำระเงิน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel htmlFor="paymentStatus-helper">ประเภท</InputLabel>
                                    <Select
                                        value={type}
                                        onChange={(event) => { this.setState({ type: event.target.value }) }}
                                        input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="เรียนออนไลน์">เรียนออนไลน์</MenuItem>
                                        <MenuItem value="เรียนออนไลน์+เรียนสด">เรียนออนไลน์+เรียนสด</MenuItem>
                                    </Select>
                                    <FormHelperText>ประเภทการเรียน</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            ยกเลิก
                        </Button>
                        <Button onClick={this.updateMyCourse} color="primary">
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Editor);